var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkippedTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.333 1.333)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#B39901",
    width: 13.333,
    height: 13.333,
    rx: 6.667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.723 7.61 4.32 6.207a.647.647 0 0 0-.451-.177.656.656 0 0 0-.661.653c0 .177.064.325.193.443l1.87 1.887a.602.602 0 0 0 .444.177c.178 0 .33-.059.46-.177l3.757-3.79a.568.568 0 0 0 .194-.435.648.648 0 0 0-.21-.468.612.612 0 0 0-.452-.177.637.637 0 0 0-.467.194L5.723 7.61z",
    fill: "#FFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkippedTick);
export default __webpack_public_path__ + "static/media/skipped-tick.e626efb0df8b937209a9129ae1e1c13a.svg";
export { ForwardRef as ReactComponent };